var _circle, _circle2, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcOutgoingCall = function SvgIcOutgoingCall(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#FFC19D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.728,
    cy: 19.726,
    r: 16.9213,
    fill: "#FFEDDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6335 23.3295L23.8683 21.5618C23.2378 20.9305 22.1661 21.183 21.9139 22.0037C21.7248 22.572 21.0943 22.8876 20.5269 22.7613C19.266 22.4457 17.5638 20.8042 17.2486 19.4784C17.0595 18.9102 17.4377 18.2789 18.0051 18.0895C18.8247 17.837 19.0769 16.7637 18.4465 16.1324L16.6812 14.3647C16.1768 13.9227 15.4203 13.9227 14.979 14.3647L13.7812 15.5642C12.5833 16.8268 13.9072 20.1729 16.8703 23.1401C19.8334 26.1074 23.1748 27.4963 24.4357 26.2336L25.6335 25.0341C26.0749 24.529 26.0749 23.7715 25.6335 23.3295Z",
    fill: "#FFA36E"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcOutgoingCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-outgoing-call.dab3cf1c.svg";
export { ForwardRef as ReactComponent };